import classNames from 'classnames';
import React, { FC, MouseEventHandler } from 'react';

import { IcDoneIcon } from '@gem/icons';

import { IconView } from '../../IconView/IconView';
import { ISelectorMenuItem } from '../Selector.types';
import styles from './SelectorItem.styles.m.css';

interface ISelectorItemProps<K extends string = string> {
  item: ISelectorMenuItem<K>;
  className?: string;
}

export const SelectorItem: FC<ISelectorItemProps> = (props) => {
  const { item, className } = props;

  const containerClassName = classNames(styles.container, className, {
    [styles.isSelected]: item.isSelected,
  });

  const handleMouseDown: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
  };

  return (
    <button
      className={containerClassName}
      onClick={(): void => item.onClick(item.key)}
      onMouseDown={handleMouseDown}
      disabled={item.isDisabled}
    >
      {item.isSelected && (
        <IconView
          className={styles.checkIcon}
          Icon={IcDoneIcon}
        />
      )}
      {item.title && (
        <span className={classNames(styles.title, styles.titleSelected)}>{item.title}</span>
      )}
    </button>
  );
};
